import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./subsection.module.scss";
import Image from "@Components/Image";
import { REFERRAL_PAGE_STATIC_URL } from "constants/index";
import CustomLink from "@Components/CustomLink";
import useIsDesktop from "hooks/useIsDesktop";

import wrapperHOC from "@Utils/wrapperHOC";
import { TRUSTPILOT_RATING } from "constants/configConstants";

type SubsectionProps = {
  title: string;
  subtitle: string;
  children: any;
  withSidePadding?: boolean;
  greyBg?: boolean;
  subtitleH4?: boolean;
  titleH2?: boolean;
  subSectionPaddingReduced?: boolean;
  trustpilotBadge?: boolean;
};

const Subsection = ({
  title,
  subtitle,
  children,
  withSidePadding = true,
  greyBg = false,
  subtitleH4 = false,
  titleH2 = false,
  subSectionPaddingReduced = false,
  trustpilotBadge = false,
}: SubsectionProps) => {
  const isDesktop = useIsDesktop();
  return (
    <div
      className={formatClassNames(
        subSectionPaddingReduced ? styles.subsectionContainerReducedPadding : {},
        withSidePadding ? styles.subsectionContainer : styles.subSectionContainerNoPadding,
        greyBg ? styles.bgColor : {},
        styles.paddingForReferralPage,
        trustpilotBadge ? styles.trsutpilot : {},
      )}
    >
      {isDesktop && (
        <div className={withSidePadding ? styles.header : styles.headerWithPadding}>
          {titleH2 ? (
            <h2 className={styles.title}>{title}</h2>
          ) : (
            <h4 className={styles.title}>{title}</h4>
          )}
          {subtitleH4 ? (
            <h4 className={styles.subtitle}>{subtitle}</h4>
          ) : (
            <h5 className={styles.subtitle}>{subtitle}</h5>
          )}
        </div>
      )}
      {!isDesktop && (
        <div className={withSidePadding ? styles.header : styles.headerWithPadding}>
          {titleH2 ? (
            <h2 className={styles.titleMobile}>{title}</h2>
          ) : (
            <h4 className={styles.titleMobile}>{title}</h4>
          )}
          {subtitleH4 ? (
            <h4 className={styles.subtitleMobile}>{subtitle}</h4>
          ) : (
            <h5 className={styles.subtitleMobile}>{subtitle}</h5>
          )}
        </div>
      )}
      {trustpilotBadge && (
        <>
          {isDesktop && (
            <CustomLink
              to="https://www.trustpilot.com/review/amberstudent.com"
              target="_blank"
              redirect
            >
              <div className={styles.trustpilotContainer}>
                <div className={styles.trustpilotStarText}>
                  <Image
                    src={`${REFERRAL_PAGE_STATIC_URL}/star.svg`}
                    alt="trsutpilot-star"
                    height="20"
                    width="20"
                  />
                  <div className={styles.trustpilotText}>Trustpilot</div>
                </div>
                <div className={styles.trustpilotBadge}>
                  <span>{TRUSTPILOT_RATING}/5</span>
                </div>
              </div>
            </CustomLink>
          )}
          {!isDesktop && (
            <CustomLink
              to="https://www.trustpilot.com/review/amberstudent.com"
              target="_blank"
              redirect
            >
              <div className={styles.trustpilotContainer}>
                <div className={styles.trustpilotStarText}>
                  <Image
                    src={`${REFERRAL_PAGE_STATIC_URL}/star.svg`}
                    alt="trsutpilot-star"
                    height="20"
                    width="20"
                  />
                  <div className={styles.trustpilotText}>Trustpilot</div>
                </div>
                <div className={styles.trustpilotBadge}>
                  <span>{TRUSTPILOT_RATING}/5</span>
                </div>
              </div>
            </CustomLink>
          )}
        </>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default wrapperHOC(Subsection, {
  componentName: "Subsection-Referral",
  showForChina: true,
});
